var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElevator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_164211479428045152907895990619154411533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 18,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 4.5L8.22556 12.2748C7.85042 12.6519 7.85141 13.2643 8.22854 13.6394C8.41115 13.822 8.65231 13.9213 8.90936 13.9213H8.91134C9.16938 13.9213 9.41153 13.821 9.59414 13.6374L15.9994 7.22723L22.4086 13.6404C22.5912 13.821 22.8314 13.9203 23.0864 13.9203H23.0894C23.3425 13.9203 23.5926 13.8181 23.7722 13.6384C23.9548 13.4558 24.055 13.2137 24.055 12.9566C24.055 12.6986 23.9548 12.4574 23.7732 12.2748L15.9994 4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94521 19.0434C7.93926 19.3014 8.03354 19.5456 8.21119 19.7312L15.98 27.5L23.7568 19.7262C24.123 19.354 24.122 18.7466 23.7538 18.3735C23.3807 17.9954 22.7693 17.9904 22.3902 18.3646L15.98 24.7688L9.57083 18.3626C9.38723 18.1889 9.14905 18.1006 8.91185 18.1006C8.67168 18.1006 8.43151 18.1899 8.24394 18.3675C8.05736 18.5462 7.95117 18.7854 7.94521 19.0434Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_164211479428045152907895990619154411533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0Z",
    fill: "url(#hinava_random_uuid_25884935340518131790335711163419426165)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_25884935340518131790335711163419426165",
    x1: 16,
    y1: 10.5107,
    x2: 16,
    y2: 29.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/elevator.4db1b32587425f24e5efcb98b2a30a94.svg";
export { ForwardRef as ReactComponent };